type Props = {
  title: string;
  label: string;
  path: string;
  reading_time: string;
  date_published: string;
  banner: string;
  host: string;
};

export const Trends: Props[] = [
  {
    title: "Product Update",
    label:
      "New Endpoints for Zambia, Kenya, PEP Transparency Portal, and Improved Features Now Live!",
    path: "https://blog.prembly.com/explore-new-features-zambia-kenya/",
    reading_time: "4 mins read",
    date_published: "August 12, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/08/Premblys-July-Product-Updates.jpeg",
    host: "Identityradar",
  },
  {
    title: "Introducing IdentityRadar’s Transaction Monitoring In Beta Mode",
    label:
      "As the online terrain constantly evolves, fraudsters are also finding new ways to bypass the various fraud prevention measures businesses deploy today.",
    path: "https://blog.prembly.com/introducing-identityradars-transaction-monitoring-in-beta-mode/",
    reading_time: "2 mins read",
    date_published: "June 13, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/06/Product-updates-radar-header-.png",
    host: "Identityradar",
  },
  {
    title:
      "Understanding the Role of Risk-Based Scorecards in AML Transaction Monitoring",
    label:
      "The Risk-Based Scorecard stands as a cornerstone within Anti-Money Laundering (AML) frameworks, playing a crucial role in the assessment and mitigation of money laundering and terrorist financing risks.",
    path: "https://blog.prembly.com/introducing-identityradars-transaction-monitoring-in-beta-mode/",
    reading_time: "2 mins read",
    date_published: "March 28, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/03/Prembly-Blog-Mar-7.png",
    host: "Identityradar",
  },
  {
    title: "Boost Your Fraud Prevention",
    label:
      "Protecting your business from online fraud is an ongoing and challenging task, but with our AI-powered solution, Identityradar, you can experience seamless integration for immediate risk detection during onboarding, supported by flexible APIs for effective fraud management.",
    path: "https://blog.prembly.com/boost-your-fraud-prevention-check-out-whats-new-on-identityradar/",
    reading_time: "2 mins read",
    date_published: "7 May, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/05/Prembly-Blog-May-4.1-1.png",
    host: "Identityradar",
  },
  {
    title: "Elevating Anti-Money Laundering",
    label:
      "In the relentless pursuit against money laundering and in strict adherence to Anti-Money Laundering (AML) regulations, a highly effective ongoing monitoring system is imperative.",
    path: "https://blog.prembly.com/elevating-anti-money-laundering-efforts-with-top-tier-ongoing-monitoring/",
    reading_time: "2 mins read",
    date_published: "Feb 1, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/02/Prembly-Blog-Jan-6.png",
    host: "Identityradar",
  },
  {
    title:
      "Preventing Financial Crimes: The Crucial Role of AML Transaction Monitoring Tools for Businesses",
    label:
      "The increasing prevalence of financial crimes such as money laundering, terrorist financing, corruption, and human trafficking has led to the creation of AML/CTF laws by international organizations such as FATF and government officials.",
    path: "https://blog.prembly.com/preventing-financial-crimes-the-crucial-role-of-aml-transaction-monitoring-tools-for-businesses/",
    reading_time: "3 mins read",
    date_published: "Feb 27, 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2024/02/Prembly-Blog-Feb-11.png",
    host: "Identityradar",
  },
  {
    title: "Redefining Fraud Detection",
    label:
      "In an environment witnessing escalating online activity and increasingly sophisticated fraudsters, digital businesses in Africa face a daunting challenge in safeguarding their operations from fraud.",
    path: "https://blog.prembly.com/premblys-identityradar-redefines-fraud-prevention-for-african-businesses/",
    reading_time: "4 mins read",
    date_published: "2 Mar 2024",
    banner:
      "https://blog.prembly.com/wp-content/uploads/2023/12/Idradar-Blog-Dec-1.png",
    host: "Identityradar",
  },
];
